import { ROUTES_NAMES } from '@/constants';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const beforeEnterConfirmForgotPasswordRoute = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  const clientId = to.query.client_id;
  const redirectURI = to.query.redirect_uri;
  const email = to.query.email;
  const code = to.query.code;

  if (!clientId || !redirectURI || !email || !code) {
    return next({ name: ROUTES_NAMES.error });
  }

  store.dispatch('setClientID', clientId);
  store.dispatch('setEmailToResetPassword', email);
  store.dispatch('setCodeToResetPassword', code);
  store.dispatch('setRedirectURI', redirectURI);
  next();
};
